import { Component, input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ContactFormData } from '../order-contact.store';
import { DecimalPipe } from '@angular/common';
import { CaseDto } from '../../../shared/Models/CaseDto';

@Component({
  selector: 'debtor-panel-order-contact-confirmation',
  templateUrl: './order-contact-confirmation.component.html',
  styleUrls: ['./order-contact-confirmation.component.scss'],
  imports: [TranslateModule, MatFormFieldModule, MatInputModule, DecimalPipe],
})
export class OrderContactConfirmationComponent {
  public formData = input<ContactFormData | null>();
  public case = input<CaseDto | null>();
  public dateString = input<string>();
}
